(function($) {
    $(function() {
        if ($('#gallery--graveyard').length === 0) {
            return;
        }
        $('#gallery--graveyard').iziModal({
            fullscreen: true,
            openFullscreen: true,
            setFullscreen: true,
            overlay: false,
        });

        $('#feedback-modal').iziModal({
            overlay: true,
            onClosed: () => resetFeedbackModalFields(),
        });

        $('#success-modal').iziModal({
            title: '',
            headerColor: '#008220',
            timeout: 12000,
            width: 400,
            timeoutProgressbar: true,
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown',
            pauseOnHover: false,
            radius: 0,
            position: 'center',
            overlay: false,
            bottom: 0,
        });

        $('#error-modal').iziModal({
            title: '',
            headerColor: '#FF112D',
            timeout: 12000,
            width: 300,
            timeoutProgressbar: true,
            pauseOnHover: true,
            radius: 0,
            overlay: false,
            position: 'center',
            bottom: 0,
        });

        $(document).on('click', '.js-open-gallery', function(event) {
            event.preventDefault();
            // no image, return
            if ($(this).css('background-image') === 'none') {
                return;
            }

            $('#gallery--graveyard').removeClass('visible-print');
            $('#gallery--graveyard').iziModal('open', {
                transition: 'fadeIn',
            });
            $('.js-modal-slider').slick('setPosition');
        });

        $(document).on('click', '.js-open-feedback', function(event) {
            event.preventDefault();
            $('#feedback-modal').iziModal('open');
        });

        $(document).on('keypress', function(e) {
            if (e.which == 27) {
                $('#gallery--graveyard').iziModal('close');
            }
        });
    });
})(jQuery);
